import React from "react";

import { cn } from "./utils";

interface Props {
  className?: string;
  children: React.ReactNode;
}

export function Pill({ children, className }: Props) {
  return (
    <div
      className={cn(
        "bg-white bg-opacity-30 text-gray-300 rounded-full px-2 w-fit",
        className,
      )}
    >
      {children}
    </div>
  );
}
